import axios from "../axios";

export const returnAdditionalAgreement = (applicationId, additionalAgreementId, form) => {
    return axios
        .post(`docflow/applications/${applicationId}/additional-agreement/${additionalAgreementId}/return`, form)
        .then(response => response.data)
}

export const acceptAdditionalAgreement = (applicationId, additionalAgreementId, form) => {
    return axios
        .post(`docflow/applications/${applicationId}/additional-agreement/${additionalAgreementId}/confirm`, form)
        .then(response => response.data)
}

export default {
    returnAdditionalAgreement,
    acceptAdditionalAgreement,
};
